import { keepPreviousData } from '@tanstack/react-query';

import { AppInventoryItemResponse } from '@playq/octopus2-economy';
import { ItemID } from '@playq/services-bookkeeper';
import { GenericFailure } from '@playq/services-shared';
import { PermModule } from '@playq/octopus2-auth';

import { IUseQueryOptionsExtended, useEitherQuery } from '/api/service-hooks';
import { useModulePermissions } from '/hooks';

import { appsInventoryRetrieveKeys, appsInventoryService } from './constants';

export const useAppsInventoryRetrieve = (
  id?: ItemID,
  version?: number,
  options?: IUseQueryOptionsExtended<AppInventoryItemResponse | undefined, GenericFailure | Error>
) => {
  const { canRead } = useModulePermissions(PermModule.EconomyInventory);

  const { mutate, ...res } = useEitherQuery(
    appsInventoryRetrieveKeys.concat(id, version),
    () => appsInventoryService.retrieve(id as ItemID, version),
    {
      placeholderData: keepPreviousData,
      staleTime: 10000,
      ...options,
      enabled: options?.enabled !== false && id !== undefined && canRead,
      meta: {
        logOnError: true,
        ...options?.meta,
      },
    }
  );

  return {
    ...res,
    mutate,
  };
};
